<template>
  <div>
    <TopContent />
    <div class="container">
      <router-view />
    </div>
    <FooterContent />
  </div>
</template>
<script>
import TopContent from './components/TopContent';
import FooterContent from './components/FooterContent';
export default {
  name: 'baseLayout',
  components: {
    TopContent,
    FooterContent,
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: 0 15px;
  padding-bottom: 15px;
}
</style>
